import React, { useState } from 'react';
import { Outlet } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import { Menu } from 'lucide-react';
import Sidebar from './Sidebar';
import TopHeader from './TopHeader';


const AuthTemplate: React.FC = () => {
  const [sidebarOpen, setSidebarOpen] = useState(false);

  return (
    <div className="min-h-screen bg-background bg-slate-950 text-slate-100 flex">
      {/* Global gradient mesh */}
      <div className="pointer-events-none fixed inset-0 -z-10">
        <div
          className="absolute -top-40 -right-40 h-[520px] w-[520px] rounded-full blur-3xl opacity-70"
          style={{
            background:
              "radial-gradient(closest-side, rgba(79,70,229,.35), rgba(79,70,229,0) 70%), radial-gradient(closest-side, rgba(236,72,153,.25), rgba(236,72,153,0) 70%)",
          }}
        />
        <div
          className="absolute -bottom-40 -left-40 h-[520px] w-[520px] rounded-full blur-3xl opacity-70"
          style={{
            background:
              "radial-gradient(closest-side, rgba(14,165,233,.28), rgba(14,165,233,0) 70%), radial-gradient(closest-side, rgba(56,189,248,.18), rgba(56,189,248,0) 70%)",
          }}
        />
      </div>

      {/* Mobile sidebar overlay */}
      <Sidebar 
        isOpen={sidebarOpen} 
        onClose={() => setSidebarOpen(false)} 
        isMobile={true} 
      />

      {/* Fixed left sidebar */}
      <Sidebar />

      {/* Main content area */}
      <div className="flex-1 flex flex-col min-h-screen">
        {/* Top Header */}
        <TopHeader />
        
        {/* Mobile menu button */}
        <div className="lg:hidden p-4 border-b border-border">
          <Button
            variant="ghost"
            size="sm"
            onClick={() => setSidebarOpen(true)}
            className="flex items-center gap-2"
          >
            <Menu className="h-4 w-4" />
            Menu
          </Button>
        </div>
        
        <main className="flex-1 p-6">
          <Outlet />
        </main>
      </div>
    </div>
  );
};

export default AuthTemplate; 